import CustomModal from "Components/Common/CustomModal/CustomModal";
import Button from "Components/Common/Button/Button";
import "./ProjectStageModal.scss";

const GC_STAGE_LABELS: Record<string, string> = {
  gc_pre_construction_requirement: "GC Pre-Construction Requirements",
  gc_pre_construction_checklist: "GC Pre-Construction Checklist",
  gc_sov_submission: "GC Schedule of Values Submission",
  gc_requirements: "GC Requirements",
};

const GC_PENDING_STAGES = new Set(Object.keys(GC_STAGE_LABELS));

interface ProjectStageModalProps {
  show: boolean;
  onClose: () => void;
  projectName?: string;
  projectStage?: string;
}

export function isGCPendingStage(stage?: string): boolean {
  return !!stage && GC_PENDING_STAGES.has(stage);
}

export default function ProjectStageModal({
  show,
  onClose,
  projectName,
  projectStage,
}: ProjectStageModalProps) {
  const stageLabel = projectStage
    ? (GC_STAGE_LABELS[projectStage] ?? projectStage)
    : "—";

  return (
    <CustomModal
      show={show}
      handleClose={onClose}
      title="Project Not Yet Ready for Review"
      isCrossBtn={true}
      isFooterVisible={true}
      footerContent={
        <Button className="btn btn-primary" onClick={onClose}>
          Got it
        </Button>
      }
    >
      <div className="psm">
        <div className="psm-header">
          <div className="psm-icon">⏳</div>
          <div>
            <div className="psm-name">{projectName ?? "This project"}</div>
            <div className="psm-stage">
              Current stage: <span>{stageLabel}</span>
            </div>
          </div>
        </div>

        <p className="psm-desc">
          This project is currently awaiting input from the General Contractor.
          The GC has not yet completed their pre-construction submission, so
          there are no details available to view or edit at this time.
        </p>

        <div className="psm-next">
          <strong>What happens next?</strong>
          <ul>
            <li>
              The GC completes their requirements checklist and SOV submission.
            </li>
            <li>
              Once submitted, the project will move to the admin review stage.
            </li>
            <li>
              You will then be able to view and edit the full project details.
            </li>
          </ul>
        </div>
      </div>
    </CustomModal>
  );
}
